import { createSelector } from 'reselect';

import { getColorLabels, getColorOptions } from '../../helpers/colorsHelper';
import { isHaveTeammatePermission } from '../helpers/user';

const selectStoredColorLabels = (state) => state.user?.team?.settings?.colorLabels;

/**
 * Catalog renders one picker per thumbnail, so the normalized configuration is computed
 * once per store change instead of once per component instance.
 */
export const selectColorLabels = createSelector(
  selectStoredColorLabels,
  getColorLabels,
);

export const selectColorOptions = createSelector(
  selectStoredColorLabels,
  getColorOptions,
);

export const selectCanManageColorLabels = (state) => (
  isHaveTeammatePermission('manageColorLabels', state.user)
);

export default {
  selectColorLabels,
  selectColorOptions,
  selectCanManageColorLabels,
};
